/**
 * Simple carousel functionality
 */
export function initCarousel() {
  const carousels = document.querySelectorAll('[data-carousel]');
  
  carousels.forEach((carousel) => {
    if (carousel.dataset.initialized === 'true') {
      return;
    }
    
    const track = carousel.querySelector('.g-carousel__track');
    const slides = carousel.querySelectorAll('.g-carousel__slide');
    const prevButton = carousel.querySelector('.g-carousel__prev');
    const nextButton = carousel.querySelector('.g-carousel__next');
    const currentCounter = carousel.querySelector('.g-carousel__current');
    const captionText = carousel.querySelector('.g-carousel__caption-text');
    const captionContainer = carousel.querySelector('.g-carousel__caption');
    
    if (!track || slides.length <= 1) {
      if (currentCounter) {
        const counter = currentCounter.closest('.g-carousel__counter');
        if (counter) counter.style.display = 'none';
      }
      if (captionContainer) {
        captionContainer.style.display = 'none';
      }
      carousel.dataset.initialized = 'true';
      return;
    }

    carousel.setAttribute('aria-live', 'polite');
    
    const captions = Array.from(slides).map((slide) => {
      const figcaption = slide.querySelector('figcaption');
      return figcaption ? figcaption.textContent.trim() : '';
    });
    
    let currentIndex = 0;
    const totalSlides = slides.length;
    
    const updateSlideVisibility = (activeIndex) => {
      slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index !== activeIndex ? 'true' : 'false');
      });
    };
    
    const updateCarousel = () => {
      const translateX = -currentIndex * 100;
      track.style.transform = `translateX(${translateX}%)`;
      
      if (currentCounter) {
        currentCounter.textContent = currentIndex + 1;
      }
      
      if (captionText && captions[currentIndex]) {
        captionText.textContent = captions[currentIndex];
        if (captionContainer) {
          captionContainer.style.display = 'block';
        }
      } else if (captionContainer) {
        captionContainer.style.display = 'none';
      }

      updateSlideVisibility(currentIndex);
    };
    
    const goToSlide = (index) => {
      currentIndex = index;
      if (currentIndex < 0) {
        currentIndex = totalSlides - 1;
      } else if (currentIndex >= totalSlides) {
        currentIndex = 0;
      }
      updateCarousel();
    };
    
    const nextSlide = () => {
      goToSlide(currentIndex + 1);
    };
    
    const prevSlide = () => {
      goToSlide(currentIndex - 1);
    };
    
    if (nextButton) {
      nextButton.addEventListener('click', nextSlide);
    }
    
    if (prevButton) {
      prevButton.addEventListener('click', prevSlide);
    }
    
    carousel.dataset.initialized = 'true';
    
    updateCarousel();
  });
}
